import { Component,OnInit, ElementRef, ViewChild, Renderer2, HostListener, Inject } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper'; 
import { Title, Meta } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';
import {DOCUMENT,  isPlatformBrowser } from '@angular/common';
import {  PLATFORM_ID } from '@angular/core';
// import 'slick-carousel';
import { ViewportScroller } from '@angular/common';
import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-mobile-app-development',
  templateUrl: './mobile-app-development.component.html',
  styleUrls: ['./mobile-app-development.component.css']
})
export class MobileAppDevelopmentComponent  implements OnInit{
  baseUrl = Constants.baseUrl;
  isBrowser:boolean=false;
  constructor(private viewportScroller: ViewportScroller, private titleService: Title, @Inject(PLATFORM_ID) private platformId: Object,private seoService:SeoService,
  private metaService: Meta, private _renderer2: Renderer2,  @Inject(DOCUMENT) private _document: Document,) {      this.isBrowser=isPlatformBrowser(this.platformId);
  }
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/mobileservices/"
  },
  "headline": "Mobile App Development Services - Android, iOS",
  "description": "A mobile application helps businesses to directly communicate with its customers and find multiple growth opportunities.",
  "image": "https://mitresource.com/assets/images/mobile/Ar-image.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-28"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();

    if (this.isBrowser) {
    AOS.init({disable: 'mobile', duration: 2000,once: true, 
      delay: 500,});
    AOS.refresh();
    }
  }
 
  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }
 
  private setTitleAndMetaTags(): void {
    // Set page title
    this.titleService.setTitle('Mobile App Development Services - Android, iOS');

    // Set meta tags
    this.metaService.addTags([
      { name: 'description', content: 'We provide hybrid, native, iOS, Android, and cross-platform Enterprise Mobile Application (App) development services & solutions.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Mobile App Development Services - Android, iOS' },
      { property: 'og:url', content: 'https://mitresource.com/mobileservices/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/mobile/android-image.png' },
      { property: 'og:description', content: 'We provide hybrid, native, iOS, Android, and cross-platform Enterprise Mobile Application (App) development services & solutions' },
    ]);

  }
}
